import * as React from "react";
import { observer, inject } from "mobx-react";
import { action, observable } from "mobx";
import { hashHistory } from "react-router";
import SeekerStore from "../../stores/seekerStore";
import DCIAStore from "../../stores/dciaStore";
import BackButton from "../../components/widgets/backBtn";
import { Grid, Row, Col } from "react-flexbox-grid";
import TextField from "material-ui/TextField";
import CheckBox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Input, { InputLabel, InputAdornment } from "material-ui/Input";
import Button from "material-ui/Button";
import { ILocalization, IMonth } from "../../models/localization";
import Busy from "../../components/widgets/busy";
import * as s from "./dcia.css";
import { BusyEvent, LookupType } from "../../models/enums";
import { DCIAApplication, EmploymentStatusType, Programs } from "../../models/client/dcia/DCIAApplication";
import { LookupValue } from "../../models/lookup";


@inject("store") @observer
export default class DCIAFormVw extends React.Component<{ store: SeekerStore }, {}> {
  private _dciaStore: DCIAStore;
  @observable firstname: string;
  @observable lastname: string;

  constructor(props: any) {
    super(props);
    this._dciaStore = this.props.store.dciaStore;
  }

  componentWillMount() {
    this.props.store.dciaStore.initApplication();
  }

  @action handleChange = (e:any ): void => {
    this[e.target.id] = e.target.value;
  }
  private getMonths(): JSX.Element[] {
    const months: JSX.Element[] = [];
    this.props.store.localization.fields.months.map((m: IMonth, i): void => {
      months.push(<MenuItem key={i} value={m.ndx}>{m.mon}</MenuItem>);
    });
    return months;
  }
  private getYears(): JSX.Element[] {
    const yrs: JSX.Element[] = [];
    let start: number = 0;
    let end: number = 100;
    start = new Date().getFullYear();
    end = start - 80;
    for (let i: number = start; i >= end; --i) {
      yrs.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
    }
    return yrs;
  }
  private getDays(): JSX.Element[] {
    const days: JSX.Element[] = [];
    for (let i: number = 1; i <= 31; i++) {
      if (i < 10) {
        days.push(<MenuItem key={i} value={i}>{`0${i}`}</MenuItem>);
      } else {
        days.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
    }
    return days;
  }
  private getAge(): JSX.Element[] {
    let items: JSX.Element[] = [];
    let i: number;
    for (i = 15; i < 80; i++) {
      items.push(<MenuItem key={i} value={i}>{i.toString()}</MenuItem>);
    }
    return items;
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;   
    const app: DCIAApplication = this._dciaStore.applicant;
    const checked: any = { color: "#5B6770", marginTop: "3px" };
    const formControl: any = { minWidth: "260px", marginTop: "-3px" };
    const dateForm: any = { minWidth: "70px" };
    const formMax: any = { maxWidth: "240px" };
    return (<div>
      <BackButton />
      <Busy show={this.props.store.viewState.isBusy(BusyEvent.LoadProfile)} size="lg" center={true} />
      {!this.props.store.viewState.isBusy(BusyEvent.LoadProfile) && !this._dciaStore.submitted && <Grid className={s.container}>
        <Row>
          <h4 className={s.blueHeader}>DCIA Application</h4>
        </Row>
        <Row>
          <Col xs={12} sm={5}><TextField fullWidth id="firstname" error={this._dciaStore.firstname.length === 0 && this._dciaStore.validated} label={local.dcia.firstname} value={this._dciaStore.firstname || ""} onChange={(e: any) => this._dciaStore.handleNameChange(e)} /></Col>
          <Col xs={12} sm={5}><TextField fullWidth id="lastname" error={this._dciaStore.lastname.length === 0 && this._dciaStore.validated} label={local.dcia.lastname} value={this._dciaStore.lastname || ""} onChange={(e: any) => this._dciaStore.handleNameChange(e)} /></Col>
          <Col xs={12} sm={2}><TextField fullWidth id="date" disabled={true} label={local.dcia.date} value={app.date.toDateString() || ""} onChange={(e: any) => this._dciaStore.handleDateChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={8}><TextField fullWidth id="street1" error={this._dciaStore.applicant.address.street1.length === 0 && this._dciaStore.validated} label={local.dcia.street1} value={app.address.street1 || ""} onChange={(e: any) => this._dciaStore.handleAddressChange(e)} /></Col>
          <Col xs={12} sm={4}><TextField fullWidth id="city" error={this._dciaStore.applicant.address.city.length === 0 && this._dciaStore.validated} label={local.dcia.city} value={app.address.city || ""} onChange={(e: any) => this._dciaStore.handleAddressChange(e)} /></Col>
          <Col xs={12} sm={8}><TextField fullWidth id="street2" label={local.dcia.street2} value={app.address.street2 || ""} onChange={(e: any) => this._dciaStore.handleAddressChange(e)} /></Col>
          <Col xs={6} sm={2}><TextField fullWidth id="state" error={this._dciaStore.applicant.address.state.length === 0 && this._dciaStore.validated} label={local.dcia.state} value={app.address.state || ""} onChange={(e: any) => this._dciaStore.handleAddressChange(e)} /></Col>
          <Col xs={6} sm={2}><TextField fullWidth id="zip" error={this._dciaStore.applicant.address.zip.length < 5 && this._dciaStore.validated} label={local.dcia.zip} value={app.address.zip || ""} onChange={(e: any) => this._dciaStore.handleAddressChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={12} sm={4}><TextField fullWidth id="ward" error={this._dciaStore.applicant.ward.length === 0 && this._dciaStore.validated} label={local.dcia.ward} value={app.ward || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
          <Col xs={12} sm={8}><TextField fullWidth id="email" error={this._dciaStore.applicant.email.length === 0 && this._dciaStore.validated} label={local.dcia.emailAddress} value={app.email || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
          <Col xs={12} sm={6}><TextField fullWidth id="phone" error={this._dciaStore.applicant.phone.length === 0 && this._dciaStore.validated} label={local.dcia.telephoneNumber} value={app.phone || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
          <Col xs={12} sm={6}><TextField fullWidth id="altPhone" label={local.dcia.alternativeNumber} value={app.altPhone || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>1.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.resident && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.dcResident}</p>
            <FormControlLabel control={<CheckBox checked={app.resident} style={checked} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("resident", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox checked={!app.resident && this._dciaStore.resident} style={checked} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("resident", !chk)} />} label={local.dcia.no} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>2.</p></Col>
          <Col xs={10} sm={6} md={4} lg={3}>
            <FormControl style={formControl}>
              <InputLabel htmlFor="gender">{(this._dciaStore.applicant.gender === "" && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.gender}</InputLabel>
              <Select
                fullWidth
                name="gender"
                value={app.gender}
                onChange={(e:any) => this._dciaStore.handleSelectChange(e)}>
                {this.props.store.localization.getLookup(LookupType.Gender).map((d: LookupValue, i: number) => {
                  return (<MenuItem key={"gender-" + i} value={d.order.toString()}>{d.value}</MenuItem>)
                })}
              </Select>
            </FormControl>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>3.</p></Col>
          <Col xs={10} sm={6} md={3}>
            <FormControl fullWidth style={formMax}>
              <InputLabel htmlFor="age">{(this._dciaStore.applicant.age === 0 && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.age}</InputLabel>
              <Select
                fullWidth
                name="age"
                value={app.age || ""}
                onChange={(e: any) => this._dciaStore.handleSelectChange(e)}>
                {this.getAge()}
              </Select>
            </FormControl>
          </Col>
          <Col xs={12} sm={12} md={2}><p style={{ marginTop: "24px" }}>{(this._dciaStore.applicant.dob === null && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.birthdate}</p></Col>
          <Col xs={4} sm={4} md={2}>
            <FormControl style={dateForm} >
              <InputLabel htmlFor="month">{local.register.month}</InputLabel>
              <Select input={<Input id="month" />} name="month" value={this._dciaStore.month} onChange={(e: any) => this._dciaStore.handleDateChange(e)}>
                {this.getMonths()}
              </Select>
            </FormControl>
          </Col>          
          <Col xs={4} sm={4} md={2}>
            <FormControl style={dateForm}>
              <InputLabel htmlFor="day">{local.register.day}</InputLabel>
              <Select input={<Input id="day" />} name="day" value={this._dciaStore.day} onChange={(e: any) => this._dciaStore.handleDateChange(e)}>
                {this.getDays()}
              </Select>
            </FormControl>
          </Col>
          <Col xs={4} sm={4} md={2}>
            <FormControl style={dateForm}>
              <InputLabel htmlFor="year">{local.register.year}</InputLabel>
              <Select input={<Input id="year" />} name="year" value={this._dciaStore.year} onChange={(e: any) => this._dciaStore.handleDateChange(e)}>
                {this.getYears()}
              </Select>
            </FormControl>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>4.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.highSchoolGED && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.educationLevel}</p>
            <FormControlLabel control={<CheckBox style={checked} checked={app.highSchoolGED} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("highSchoolGED", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox style={checked} checked={!app.highSchoolGED && this._dciaStore.highSchoolGED} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("highSchoolGED", !chk)} />} label={local.dcia.no} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>5.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.casasTest && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.casas}</p>
            <FormControlLabel control={<CheckBox style={checked} checked={app.casasTest} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("casasTest", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox style={checked} checked={!app.casasTest && this._dciaStore.casasTest} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("casasTest", !chk)} />} label={local.dcia.no} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>6.</p></Col>
          <Col xs={10}><p>{(this._dciaStore.applicant.employmentStatus === EmploymentStatusType.Unknown && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.employmentStatus}</p></Col>
          <Col xs={10} sm={6} md={5} lg={4}>
            <FormControl fullWidth>
              <InputLabel  htmlFor="employmentStatus">Select one</InputLabel>
              <Select
                fullWidth
                name="employmentStatus"
                value={app.employmentStatus || ""}
                onChange={(e: any) => this._dciaStore.handleSelectChange(e)}>
                <MenuItem key="emp-0" value={EmploymentStatusType.FullTime}>Employed, Fulltime 35 hours or more</MenuItem>
                <MenuItem key="emp-1" value={EmploymentStatusType.PartTime}>Employed, Part-time 34 hours or less</MenuItem>
                <MenuItem key="emp-2" value={EmploymentStatusType.NotEmployed}>Not Employed</MenuItem>
                <MenuItem key="emp-3" value={EmploymentStatusType.Retired}>Retired</MenuItem>
                <MenuItem key="emp-4" value={EmploymentStatusType.Disabled}>Disabled, not able to work</MenuItem>
              </Select>
            </FormControl>
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>7.</p></Col>
          <Col xs={10}><p>{((this._dciaStore.applicant.employmentStatus === EmploymentStatusType.FullTime || this._dciaStore.applicant.employmentStatus === EmploymentStatusType.PartTime) && this._dciaStore.applicant.hoursWorkedMF.length === 0 && this._dciaStore.validated) ? <span className={s.errorText}>Required for fulltime and part-time employees. </span> : null}{local.dcia.hours}</p></Col>
          <Col xs={10}><TextField multiline fullWidth id="hoursWorkedMF" label="Enter if you selected fulltime or part-time employement status." value={app.hoursWorkedMF || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>8.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.felony && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.convicted}</p>
            <FormControlLabel control={<CheckBox checked={app.felony} style={checked} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("felony", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox checked={!app.felony && this._dciaStore.felony} style={checked} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("felony", !chk)} />} label={local.dcia.no} />
          </Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>9.</p></Col>
          <Col xs={10}><p>{(this._dciaStore.applicant.felony && this._dciaStore.applicant.felonyDesc.length === 0 && this._dciaStore.validated) ? <span className={s.errorText}>Required because you answered Yes to the above. </span> : null}{local.dcia.natureOfOffense}</p></Col>
          <Col xs={12}><TextField multiline fullWidth id="felonyDesc" label="Enter if you selected YES to a felony conviction" value={app.felonyDesc || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>10.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.misdemeanor && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.misdemeanor}</p>
            <FormControlLabel control={<CheckBox style={checked} checked={app.misdemeanor} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("misdemeanor", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox style={checked} checked={!app.misdemeanor && this._dciaStore.misdemeanor} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("misdemeanor", !chk)} />} label={local.dcia.no} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>11.</p></Col>
          <Col xs={10}><p>{(this._dciaStore.applicant.misdemeanor && this._dciaStore.applicant.misdemeanorDesc.length === 0 && this._dciaStore.validated) ? <span className={s.errorText}>Required because you answered Yes to the above. </span> : null}{local.dcia.natureOfOffense}</p></Col>
          <Col xs={12}><TextField multiline fullWidth id="misdemeanorDesc" label="Enter if you selected YES to a misdemeanor conviction" value={app.misdemeanorDesc || ""} onChange={(e: any) => this._dciaStore.handleChange(e)} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>12.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.drugScreenConsent && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.drugScreening}</p>
            <FormControlLabel control={<CheckBox style={checked} checked={app.drugScreenConsent} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("drugScreenConsent", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox style={checked} checked={!app.drugScreenConsent && this._dciaStore.drugScreenConsent} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("drugScreenConsent", !chk)} />} label={local.dcia.no} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>13.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.validDriversLicense && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.driversLicense}</p>
            <FormControlLabel control={<CheckBox style={checked} checked={app.validDriversLicense} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("validDriversLicense", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox style={checked} checked={!app.validDriversLicense && this._dciaStore.validDriversLicense} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("validDriversLicense", !chk)} />} label={local.dcia.no} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={1} className={s.numberCol}><p>14.</p></Col>
          <Col xs={10} sm={11} className={s.checkBoxRow} ><p className={s.checkBoxQuestion}>{(!this._dciaStore.safetyViolations && this._dciaStore.validated) ? <span className={s.errorText}>Required </span> : null}{local.dcia.drivingViolation}</p><p style={{ fontSize: "12px", marginTop: "20px", paddingRight: "16px" }}>{`(${local.dcia.drivingDisclaimer})`}</p>
            <FormControlLabel control={<CheckBox style={checked} checked={app.safetyViolations} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("safetyViolations", chk)} />} label={local.dcia.yes} />
            <FormControlLabel control={<CheckBox style={checked} checked={!app.safetyViolations && this._dciaStore.safetyViolations} onChange={(e: object, chk: boolean) => this._dciaStore.setCheckedValue("safetyViolations", !chk)} />} label={local.dcia.no} /></Col>
        </Row>
        <br />
        <Row>
          <Col xs={12}><p>{(this._dciaStore.applicant.interests === 0 && this._dciaStore.validated) ? <span className={s.errorText}>Requires at least 1 selection </span> : null}{local.dcia.dcInfastructure}</p></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.QuickPathToEnergyAndTrades.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="Quick Path to Enery-Construction and Skilled Trades" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.QuickPathToTransportation.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="Quick Path to Transportation-COL" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.SolarWorksDC.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="Solar World DC - NABCEP Photovoltaic Associate" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.AutoTechnician.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="Auto Technician-Automotive Service Excellence (ASE)" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.OSHATraining.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="OSHA 10 hour Safety Training" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.FirstAid.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="First Aid/AED/CPR" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.ResumeAssistance.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="Resume Assistance" /></Col>
          <Col xs={12}><FormControlLabel control={<CheckBox style={checked} value={Programs.MockInterview.toString()} onChange={(e: object, chk: boolean) => this._dciaStore.addRemoveFromList(e, chk)} />} label="Mock Interview Training (Industry Specific)" /></Col>
        </Row>
        <br />
        <br />
        <Row>
          <Col xs={12}><Button raised size="large" color="secondary" onClick={() => this._dciaStore.submitForm()}>Sign & Submit</Button></Col>
        </Row>
        <br />
      </Grid>}
      {this._dciaStore.submitted && <h4 className={s.blueHeader}>Thank you, your form has been submitted.</h4>}
    </div>)
  }

}


// WEBPACK FOOTER //
// ./src/views/dciaApplication/index.tsx